require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./2017-inaugural-season.json") })
        }
      }, "path---2017-inaugural-season");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---2017-inaugural-season!./.cache/json/2017-inaugural-season.json
// module id = 452
// module chunks = 231608221292675